module.exports = "<div class=\"container-fluid footer fixed-bottom\"></div>"